// CommunityEngagementPage.js
import React from 'react';

const CommunityEngagementPage = () => {
  return (
    <div>
      <div style={{ margin: '20px 0' }}>
        <h3>Open Source Contributions</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Contributing to data engineering tools and libraries</li>
          <li>Maintaining documentation and examples for Apache Airflow workflows</li>
          <li>Sharing automation scripts and infrastructure templates</li>
        </ul>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Community Involvement</h3>
        <p><strong>Tech Meetups & Conferences:</strong></p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Regular attendee at local Python and data engineering meetups</li>
          <li>Volunteer organizer for tech community events</li>
          <li>Guest speaker on data pipeline best practices</li>
        </ul>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Knowledge Sharing</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Writing technical blog posts about data engineering challenges</li>
          <li>Creating educational content about automation and DevOps</li>
          <li>Mentoring newcomers to the data engineering field</li>
        </ul>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Creative Projects</h3>
        <p><strong>Side Projects:</strong></p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Building personal automation tools and scripts</li>
          <li>Experimenting with new technologies and frameworks</li>
          <li>Contributing to hackathons and coding challenges</li>
        </ul>
      </div>

      <p><em>A showcase of my recent community engagement, including volunteering, tools, and creative coding experiments that contribute to the tech community.</em></p>
    </div>
  );
};

export default CommunityEngagementPage;